import { CloseIcon } from "components/atoms/Icon";
import Button from "components/atoms/buttons/Button";
import Modal from "components/atoms/modal";

interface IProps {
  open: boolean;
  onClose: () => void;
  handleEndRelease: () => void;
}
function EndReleaseModal({ open = false, onClose, handleEndRelease }: IProps) {
  return (
    <Modal open={open} onClose={onClose}>
      <div className="relative rounded-2xl bg-primary p-8 text-white shadow-modal md:w-[600px]">
        <div className="flex justify-between">
          <div className="w-[95%]">
            <h1 className="font-satoshi text-2xl font-bold leading-tight">Are you sure you want to end the release?</h1>
          </div>

          <span role="button" tabIndex={0} onKeyDown={() => {}} onClick={onClose} className="cursor-pointer">
            <CloseIcon className="h-4 w-4 text-white" />
          </span>
        </div>
        <section className="mt-6 w-full font-satoshi text-sm font-450 leading-tight text-white text-opacity-70">
          By ending the release, users will only be able to purchase your Magnet through the secondary market. You can
          open up another release as long as there are remaining Magnets to release.
        </section>
        <div className="mt-10 flex justify-end gap-3">
          <Button variant="whiteOutline" text="CANCEL" onClick={onClose} additionalClasses="text-xs" />
          <Button variant="magnetiqSolid" text="END RELEASE" onClick={handleEndRelease} additionalClasses="text-xs" />
        </div>
      </div>
    </Modal>
  );
}

export default EndReleaseModal;
